export class BaseError extends Error {}

export class PermissionError extends BaseError {}
export class NotFoundError extends BaseError {}
export class AuthorizationError extends BaseError {}
export class UnknownError extends BaseError {}
